export const GET_AUTH_USER = 'GET_AUTH_USER';
export const UPDATE_AUTH_USER = 'UPDATE_AUTH_USER';
